import { Routes } from '@angular/router';

export const routes: Routes = [
  // 1. Homepage
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/home/home.component').then((m) => m.HomeComponent),
  },

  // 2. Pricing Full Comparison Page
  {
    path: 'pricing',
    loadComponent: () =>
      import('./pages/pricing/pricing-page.component').then((m) => m.PricingPageComponent),
  },

  // 3. Features Deep Dive Page
  {
    path: 'features',
    loadComponent: () =>
      import('./pages/features/features-page.component').then((m) => m.FeaturesPageComponent),
  },

  // 4. Integrations Ecosystem Page
  {
    path: 'integrations',
    loadComponent: () =>
      import('./pages/integrations/integrations-page.component').then((m) => m.IntegrationsPageComponent),
  },

  // 5. Contact & Book a Demo Page
  {
    path: 'contact',
    loadComponent: () =>
      import('./pages/contact/contact-page.component').then((m) => m.ContactPageComponent),
  },

  // 6. Free Merchant Tools Hub & Specific Calculators
  {
    path: 'tools',
    loadComponent: () =>
      import('./pages/tools/tools-hub.component').then((m) => m.ToolsHubComponent),
  },
  {
    path: 'tools/:tool',
    loadComponent: () =>
      import('./pages/tools/tools-hub.component').then((m) => m.ToolsHubComponent),
  },

  // 7. Dedicated Business Solutions Pages
  {
    path: 'solutions/:slug',
    loadComponent: () =>
      import('./pages/solutions/solution-detail.component').then((m) => m.SolutionDetailComponent),
  },
  {
    path: 'solutions',
    redirectTo: 'solutions/grocery',
    pathMatch: 'full',
  },

  // 8. SEO-Friendly Aliases (Preserve existing indexed URLs)
  {
    path: 'grocery-pos',
    redirectTo: 'solutions/grocery',
    pathMatch: 'full',
  },
  {
    path: 'restaurant-pos',
    redirectTo: 'solutions/restaurant',
    pathMatch: 'full',
  },
  {
    path: 'retail-pos',
    redirectTo: 'solutions/retail',
    pathMatch: 'full',
  },
  {
    path: 'fashion-pos',
    redirectTo: 'solutions/fashion',
    pathMatch: 'full',
  },
  {
    path: 'cafe-pos',
    redirectTo: 'solutions/cafe',
    pathMatch: 'full',
  },
  {
    path: 'pharmacy-pos',
    redirectTo: 'solutions/pharmacy',
    pathMatch: 'full',
  },
  {
    path: 'wholesale-pos',
    redirectTo: 'solutions/wholesale',
    pathMatch: 'full',
  },

  // 9. Fallback Route
  {
    path: '**',
    redirectTo: '',
  },
];
